import {
  FeatureServiceBinder,
  FeatureServiceEnvironment,
  FeatureServices,
  SharedFeatureService,
} from '@feature-hub/core';
import { Store } from 'redux';
import { getPincode } from 'src/bff';
import { FormDataFields } from 'src/types';
import {
  DpsData,
  EsOneformCoreServiceV1,
  FieldType,
  OneFormDataV1 as OneformData,
  OneFormDataV1,
  PersonV1,
} from './types';
import { BehaviorSubject } from 'rxjs';
// import { testPincodeData } from './pincode-data/pincode-person';
import { IAuthServiceV1 } from '@volkswagen-onehub/authservice/dist/v1/AuthServiceV1';
import { ProfileServiceV1Impl } from '@volkswagen-onehub/myvw_services/dist/profileService/ProfileServiceV1';
import { VumClient } from '@volkswagen-onehub/myvw_services/dist/vum/VumClient';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { AuthServiceProviderV1 } from '@volkswagen-onehub/authservice/dist/v1/AuthServiceProviderV1';
import { getAuthService } from 'src/feature-app';
import parsePhoneNumber from 'libphonenumber-js';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { checkIfIsTestPincode, getTestPincode } from './pincode-data';

export interface SharedEsOneformCoreService extends SharedFeatureService {
  readonly '1.0.0': FeatureServiceBinder<EsOneformCoreServiceV1>;
}

export interface RequiredFeatureServices extends FeatureServices {
  readonly 'service-config-provider': ServiceConfigProviderV1;
}

export const oneformCoreServiceDefinition = {
  id: 'es:oneform-core',

  dependencies: {
    featureServices: {
      'service-config-provider': '^1.0.0',
      'fa-content-service': '^1.0.0',
    },
  },

  optionalDependencies: {
    featureServices: { ['vw:authService']: '1.0.0' },
  },

  create(env: FeatureServiceEnvironment<RequiredFeatureServices>) {
    let oneFormData = {} as OneFormDataV1;
    let dpsData = {} as DpsData;
    const oneFormCoreDpsIsLoaded: BehaviorSubject<any> = new BehaviorSubject(false);

    let { 'service-config-provider': serviceConfig, ['vw:authService']: provider } = env.featureServices;

    const getLoadedState = () => oneFormCoreDpsIsLoaded;
    const get = () => oneFormData;
    const getDpsData = (): DpsData => dpsData;

    const v1 = () => ({
      featureService: {
        getLoadedState,

        get,
        getDpsData,

        set(updatedData: OneFormDataV1) {
          oneFormData = { ...updatedData };
        },

        setDpsData(updatedData: DpsData) {
          dpsData = { ...dpsData, ...updatedData };
        },

        async initializeService(useAuth: boolean) {
          await this.checkData(useAuth);
          oneFormCoreDpsIsLoaded.complete();
        },

        async checkLogin() {
          // const authService: IAuthServiceV1 = (provider as AuthServiceProviderV1)?.register('market');
          const authService = getAuthService(serviceConfig, provider as AuthServiceProviderV1);
          const endpoint = serviceConfig.configs['customer-profile']?.urlOrigin;
          const profileService = new ProfileServiceV1Impl(authService, endpoint);
          const isAuthenticated = await authService.isAuthenticated();

          if (!isAuthenticated) {
            return;
          }
          const profile = await profileService.getUserProfile();
          const email = await profileService.getUserEmail();
          // const vumClient = new VumClient(endpoint, authService);
          // const aa = await vumClient.getUserVehicleRelations();
          //DATOS PERSONALES
          if (profile.phoneNumber) {
            const parsedPhone = parsePhoneNumber(profile.phoneNumber);
            const isValidPhone = isValidPhoneNumber(profile.phoneNumber);
            if (isValidPhone) {
              this.setField('prefix', `+${parsedPhone.countryCallingCode}`);
              this.setField('cellphone', parsedPhone.nationalNumber);
            }
          }
          this.setField('name', profile.firstName);
          this.setField('surname', profile.lastName);
          this.setField('email', email);
          // this.setField('cellphone', '600000000');
          this.setField('userIsAuthenticated', isAuthenticated ? 'true' : 'false');

          // VEHÍCULOS
          // this.setField('userVehicles', [
          //   { matricula: 'A0000BC', kilometros: '30000', modelo: 'Arteon', anoMatriculacion: '' , isMainVehicle: false },
          //   { matricula: 'B0000BC', kilometros: '60000', modelo: 'T-Roc', anoMatriculacion: '' , isMainVehicle: true },
          // ]);
          // this.setField('matricula', 'A0000BC');

          // DEALER
          // this.setField('favouriteDealer', '00031');

          // LEGALES
          // this.setField('lssi', 'PERMITIDO');
          // this.setField('tmk', 'PERMITIDO');
        },

        async checkPincode(isRetry?: boolean) {
          try {
            const pincode = this.getUrlParams('pincode');

            if (pincode && checkIfIsTestPincode(pincode)) {
             // console.log(getTestPincode(pincode),'pincode');
              this.setDpsData({
                pincode: {
                  pincodeResponse: getTestPincode(pincode), 
                  pincodeError: false,
                  pincodeUsed: false,
                  noPincodeFound: false,
                },
              });
              return;
            }
            if (pincode) {
              const pincodeData = await getPincode(pincode);

              this.setDpsData({
                pincode: {
                  pincodeResponse: pincodeData.pincodeData,
                  pincodeError: pincodeData.pincodeError,
                  pincodeUsed: pincodeData.pincodeUsed,
                  noPincodeFound: false,
                },
              });
              // person.map((att) => {
              //   // this.setField(att.name, att.value);
              // });
            } else {
              this.setDpsData({
                pincode: {
                  pincodeResponse: null,
                  pincodeError: null,
                  pincodeUsed: null,
                  noPincodeFound: true,
                },
              });
            }
          } catch (error) {
            oneFormCoreDpsIsLoaded.error(error);
          }
        },

        checkUrl() {
          const dealerKvps = this.getUrlParams('dealer');
          const motivo = this.getUrlParams('motivo');
          const contactado = this.getUrlParams('contactado');
          const rating = this.getUrlParams('rating');
          const push = this.getUrlParams('push');
          const estado = this.getUrlParams('estado');
          const waid = this.getUrlParams('wa') || this.getUrlParams('waid');
          const cem = this.getUrlParams('cem');
          const mgm = this.getUrlParams('mgm');
          const adviser = this.getUrlParams('adviser');
          const or = this.getUrlParams('or');
          const dat = this.getUrlParams('dat');
          const env = this.getUrlParams('env');
          const dealer = this.getUrlParams('dealer');
          const kvps = this.getUrlParams('kvps');
          const campaign = this.getUrlParams('campaign');
          const model = this.getUrlParams('model');

          if (motivo) {
            this.setField('motivo', motivo);
          }
          if (dealerKvps) {
            this.setField('dealerKvps', dealerKvps);
          }
          if (contactado) {
            this.setDpsData({ contactado });
          }
          if (rating) {
            this.setDpsData({ rating });
          }
          if (push) {
            this.setDpsData({ push });
          }
          if (estado) {
            this.setDpsData({ estado });
          }
          if (waid) {
            this.setDpsData({ waid });
          }
          if (cem) {
            this.setDpsData({ cem });
          }
          if (mgm) {
            this.setDpsData({ mgm });
          }
          if (adviser) {
            this.setDpsData({ adviser });
          } 
          if (or) {
            this.setDpsData({ or });
          } 
          if (dat) {
            this.setDpsData({ dat });
          } 
          if (env) {
            this.setDpsData({ env });
          }
          if (dealer) {
            this.setDpsData({ dealer });
          }
          if (kvps) {
            this.setDpsData({ kvps });
          }
          if (campaign) {
            this.setDpsData({ campaign });
          }
          if (model) {
            this.setDpsData({ model });
          }
        },

        async checkData(useAuth: boolean) {
          if (useAuth) {
            await this.checkLogin();
          }
          await this.checkPincode();
          this.checkUrl();
        },

        getUrlParams(param: string) {
          if (typeof window === 'undefined') {
            return null;
          }
          if (window && window.location) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
          }
          return null;
        },

        async retryPincodeLoad() {
          await this.checkPincode();
        },

        setField(field: FieldType | string, value: any): void {
          const { person } = this.get();
          const updatedPerson: PersonV1 = { ...person };
          updatedPerson[field] = value;
          const updatedOneFormData: OneformData = { ...oneFormData, person: { ...updatedPerson } };
          this.set(updatedOneFormData);
        },

        subscribeToFields(store: Store<any>): void {
          const { fields }: { fields: FormDataFields } = store.getState().formData;
          Object.keys(fields).forEach((field) => {
            this.setField(field, fields[field]);
          });
        },
      },
    });

    return { '1.0.0': v1 };
  },
};
